import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';

import {BasicLayoutComponent} from './basic/basic.component';
import {BlankLayoutComponent} from './blank/blank.component';

import {NavigationComponent} from '../components/navigation/navigation.component';
import {TopNavBarComponent} from '../components/top-nav-bar/top-nav-bar.component';
import {CommonComponentsModule} from '../common-components.module';
import { BannersService } from '../services/banners.service';
import { AppModalModule } from '../views/modal/app-modal.module';
import {AngularMaterialImportModule} from '../components/angular-material-import-module/angular-material-import.module';
import {ContactUsModalModule} from '../views/contact-us-modal/contact-us-modal.module';
import {ParcelsModule} from '../views/parcels/parcels.module';
import {NoBuildingsModalModule} from '../views/no-buildings-modal/no-buildings-modal.module';

@NgModule({
    declarations: [
        BasicLayoutComponent,
        BlankLayoutComponent,

        NavigationComponent,
        TopNavBarComponent,
    ],
    imports: [
        BrowserModule,
        RouterModule,
        FormsModule,
        CommonComponentsModule,
        AppModalModule,
        AngularMaterialImportModule,
        ContactUsModalModule,
        NoBuildingsModalModule,
        ParcelsModule
    ],
    exports: [
        BasicLayoutComponent,
        BlankLayoutComponent,
    ],
    providers: [
        BannersService
    ]
})

export class LayoutsModule {
}



// WEBPACK FOOTER //
// /app/src/app/layouts/layouts.module.ts